/** Game Center vendor IDs — must match App Store Connect exactly. */

export const GC_LEADERBOARDS = {
  easy: "com.worldvelopers.lanedash.lb.easy",
  medium: "com.worldvelopers.lanedash.lb.medium",
  hard: "com.worldvelopers.lanedash.lb.hard",
} as const;

export const GC_ACHIEVEMENTS = {
  firstDash: "com.worldvelopers.lanedash.ach.first_dash",
  medium: "com.worldvelopers.lanedash.ach.medium",
  hard: "com.worldvelopers.lanedash.ach.hard",
  m400: "com.worldvelopers.lanedash.ach.m400",
  m1000: "com.worldvelopers.lanedash.ach.m1000",
  fleet: "com.worldvelopers.lanedash.ach.fleet",
  phantom: "com.worldvelopers.lanedash.ach.phantom",
  streak7: "com.worldvelopers.lanedash.ach.streak7",
} as const;
